import React, { useState } from 'react';
import {
  Box,
  Button,
  InputLabel,
  TextField,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  MenuItem,
  FormControl,
  Select,
  ListItemText,
  Checkbox,
  OutlinedInput,
  Chip,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  Grid,
  ListItemButton,
  Tabs, 
  Tab,
  FormGroup
} from '@mui/material';
import { SelectChangeEvent } from "@mui/material/Select";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BlackWhiteSwitch from '../components/common/BlackWhiteSwitch';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import Tooltip from '../components/common/Tooltip';
import { Theme, useTheme } from '@mui/material/styles';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PersonIcon from '@mui/icons-material/Person';
import ClearIcon from "@mui/icons-material/Clear";
// import { TabContext, TabList, TabPanel } from "@mui/lab";


// function TabPanel({ children, value, index }) {
//   return (
//     <div role="tabpanel" hidden={value !== index}>
//       {value === index && (
//         <Box sx={{ p: 2 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

const SuperAdmin = () => {
    
        const [isActive, setIsActive] = useState<boolean>(true);
        const [toggleChanged, setToggleChanged] = useState<boolean>(false);
        const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
            setIsActive(event.target.checked);
        };
        const [fromDate, setFromDate] = useState<dayjs.Dayjs | null>(null);
        const [toDate, setToDate] = useState<dayjs.Dayjs | null>(null);
        
        const [fromOpen, setFromOpen] = useState(false);
        const [toOpen, setToOpen] = useState(false);
        
        const handleDateChange = (newValue: dayjs.Dayjs | null) => {
            setToDate(newValue);
            setToOpen(false); // Close the calendar after selecting a date
        };

        const [ruleName, setRuleName] = React.useState('');
        const [ruleDescription, setRuleDescription] = React.useState('');
        const [bookingValueThreshold, setBookingValueThreshold] = React.useState('');
        const [baseAmount, setBaseAmount] = React.useState('');
        const [rulePriority, setRulePriority] = React.useState('');
        const [originCountry, setOriginCountry] = React.useState('');
        const [destinationCountry, setDestinationCountry] = React.useState('');
        const [journeyType, setJourneyType] = React.useState('');
        const [routeDemand, setRouteDemand] = React.useState('');
        const [flightDistance, setFlightDistance] = React.useState('');
        const [customerType, setCustomerType] = React.useState('');
        const [loyaltyTier, setLoyaltyTier] = React.useState('');
        const [bookingFrequency, setBookingFrequency] = React.useState('');
        const [ageGroup, setAgeGroup] = React.useState('');
        const [cabinClass, setCabinClass] = React.useState('');
        const [seatSelection, setSeatSelection] = React.useState('');
        const [addons, setAddons] = React.useState('');
        const [brandedFares, setBrandedFares] = React.useState('');
        const [fareFlexibility, setFareFlexibility] = React.useState('');
        const [bookingWindow, setBookingWindow] = React.useState('');
        const [travelSeason, setTravelSeason] = React.useState('');
        const [bookingTime, setBookingTime] = React.useState('');
        const [dayWeek, setDayWeek] = React.useState('');
        const [specialEvents, setSpecialEvents] = React.useState('');
        const [surgeThreshold, setSurgeThreshold] = React.useState('');
        const [responseStrategy, setResponseStrategy] = React.useState('');
        const [surgeMultiplier, setSurgeMultiplier] = React.useState('');
        const [monitoringFrequency, setMonitoringFrequency] = React.useState('');

        const [passengerType, setPassengerType] = React.useState('');
        const [agebasedPricing, setAgebasedPricing] = React.useState('');
        const [ticketSegments, setTicketSegments] = React.useState('');
        const [multisegmentPricing, setMultisegmentPricing] = React.useState('');
        const [groupBookingRules, setGroupBookingRules] = React.useState('');
        const [feeType, setFeeType] = React.useState('');
        const [currency, setCurrency] = React.useState('');

        const handleFeeTypeChange = (event: SelectChangeEvent) => {
            setFeeType(event.target.value);
        };
        const handleCurrencyChange = (event: SelectChangeEvent) => {
            setCurrency(event.target.value);
        };
        const handlePassengerTypeChange = (event: SelectChangeEvent) => {
            setPassengerType(event.target.value);
        };
        const handleAgebasedPricingChange = (event: SelectChangeEvent) => {
            setAgebasedPricing(event.target.value);
        };
        const handleTicketSegmentsChange = (event: SelectChangeEvent) => {
            setTicketSegments(event.target.value);
        };
        const handleMultisegmentPricingChange = (event: SelectChangeEvent) => {
            setMultisegmentPricing(event.target.value);
        };
        const handleGroupBookingRulesChange = (event: SelectChangeEvent) => {
            setGroupBookingRules(event.target.value);
        };

        const handleRulePriorityChange = (event: SelectChangeEvent) => {
            setRulePriority(event.target.value);
        };
        const handleOriginCountryChange = (event: SelectChangeEvent) => {
            setOriginCountry(event.target.value);
        };
        const handleDestinationCountryChange = (event: SelectChangeEvent) => {
            setDestinationCountry(event.target.value);
        };
        const handleJourneyTypeChange = (event: SelectChangeEvent) => {
            setJourneyType(event.target.value);
        };
        const handleRouteDemandChange = (event: SelectChangeEvent) => {
            setRouteDemand(event.target.value);
        };
        const handleFlightDistanceChange = (event: SelectChangeEvent) => {
            setFlightDistance(event.target.value);
        };
        const handleCustomerTypeChange = (event: SelectChangeEvent) => {
            setCustomerType(event.target.value);
        };
        const handleLoyaltyTierChange = (event: SelectChangeEvent) => {
            setLoyaltyTier(event.target.value);
        };
        const handleBookingFrequencyChange = (event: SelectChangeEvent) => {
            setBookingFrequency(event.target.value);
        };
        const handleAgeGroupChange = (event: SelectChangeEvent) => {
            setAgeGroup(event.target.value);
        };
        const handleCabinClassChange = (event: SelectChangeEvent) => {
            setCabinClass(event.target.value);
        };
        const handleSeatSelectionChange = (event: SelectChangeEvent) => {
            setSeatSelection(event.target.value);
        };
        const handleAddonsChange = (event: SelectChangeEvent) => {
            setAddons(event.target.value);
        };
        const handleBrandedFaresChange = (event: SelectChangeEvent) => {
            setBrandedFares(event.target.value);
        };
        const handleFareFlexibilityChange = (event: SelectChangeEvent) => {
            setFareFlexibility(event.target.value);
        };
        const handleBookingWindowChange = (event: SelectChangeEvent) => {
            setBookingWindow(event.target.value);
        };
        const handleTravelSeasonChange = (event: SelectChangeEvent) => {
            setTravelSeason(event.target.value);
        };
        const handleBookingTimeChange = (event: SelectChangeEvent) => {
            setBookingTime(event.target.value);
        };
        const handleDayWeekChange = (event: SelectChangeEvent) => {
            setDayWeek(event.target.value);
        };
        const handleSpecialEventsChange = (event: SelectChangeEvent) => {
            setSpecialEvents(event.target.value);
        };
        const handleSurgeThresholdChange = (event: SelectChangeEvent) => {
            setSurgeThreshold(event.target.value);
        };
        const handleResponseStrategyChange = (event: SelectChangeEvent) => {
            setResponseStrategy(event.target.value);
        };
        const handleSurgeMultiplierChange = (event: SelectChangeEvent) => {
            setSurgeMultiplier(event.target.value);
        };
        const handleMonitoringFrequencyChange = (event: SelectChangeEvent) => {
            setMonitoringFrequency(event.target.value);
        }; 
       const [tab, setTab] = useState(0);
       const handleTabChange = (event: any, newValue: React.SetStateAction<number>) => {
           setTab(newValue);
       };
//        const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
//             e.stopPropagation(); 
//             setFeeType(""); 
//             setCurrency(""); 
//             setPassengerType(""); 
//             setAgebasedPricing(""); 
//             setTicketSegments(""); 
//             setMultisegmentPricing(""); 
//             setGroupBookingRules(""); 
//             setRulePriority(""); 
//             setOriginCountry(""); 
//             setDestinationCountry(""); 
//             setJourneyType(""); 
//             setRouteDemand(""); 
//             setFlightDistance(""); 
//             setCustomerType(""); 
//             setLoyaltyTier(""); 
//             setBookingFrequency(""); 
//             setAgeGroup(""); 
//             setCabinClass(""); 
//             setSeatSelection(""); 
//             setAddons(""); 
//             setBrandedFares(""); 
//             setFareFlexibility(""); 
//             setBookingWindow(""); 
//             setTravelSeason(""); 
//             setBookingTime(""); 
//             setDayWeek(""); 
//             setSpecialEvents(""); 
//             setSurgeThreshold(""); 
//             setResponseStrategy(""); 
//             setSurgeMultiplier(""); 
//             setMonitoringFrequency("");
//         };
// const handleClear = (
//     e: React.MouseEvent<HTMLButtonElement>,
//     field: "surgeMultiplier" | "monitoringFrequency"
//   ) => {
//     e.stopPropagation(); 
//     if (field === "surgeMultiplier") setSurgeMultiplier("");
//     if (field === "monitoringFrequency") setMonitoringFrequency("");
//   }; 
  
const handleClear = (
  e: React.MouseEvent<HTMLButtonElement>,
  field:
    | "feeType"
    | "currency"
    | "passengerType"
    | "agebasedPricing"
    | "ticketSegments"
    | "multisegmentPricing"
    | "groupBookingRules"
    | "rulePriority"
    | "originCountry"
    | "destinationCountry"
    | "journeyType"
    | "routeDemand"
    | "flightDistance"
    | "customerType"
    | "loyaltyTier"
    | "bookingFrequency"
    | "ageGroup"
    | "cabinClass"
    | "seatSelection"
    | "addons"
    | "brandedFares"
    | "fareFlexibility"
    | "bookingWindow"
    | "travelSeason"
    | "bookingTime"
    | "dayWeek"
    | "specialEvents"
    | "surgeThreshold"
    | "responseStrategy"
    | "surgeMultiplier"
    | "monitoringFrequency"
    | "fromDate"
    | "toDate"
    | "ruleName"
    | "ruleDescription"
    | "bookingValueThreshold"
    | "baseAmount"
) => {
  e.stopPropagation(); // prevent dropdown from opening

  switch (field) {
    case "feeType":
      setFeeType("");
      break;
    case "currency":
      setCurrency("");
      break;
    case "passengerType":
      setPassengerType("");
      break;
    case "agebasedPricing":
      setAgebasedPricing("");
      break;
    case "ticketSegments":
      setTicketSegments("");
      break;
    case "multisegmentPricing":
      setMultisegmentPricing("");
      break;
    case "groupBookingRules":
      setGroupBookingRules("");
      break;
    case "rulePriority":
      setRulePriority("");
      break;
    case "originCountry":
      setOriginCountry("");
      break;
    case "destinationCountry":
      setDestinationCountry("");
      break;
    case "journeyType":
      setJourneyType("");
      break;
    case "routeDemand":
      setRouteDemand("");
      break;
    case "flightDistance":
      setFlightDistance("");
      break;
    case "customerType":
      setCustomerType("");
      break;
    case "loyaltyTier":
      setLoyaltyTier("");
      break;
    case "bookingFrequency":
      setBookingFrequency("");
      break;
    case "ageGroup":
      setAgeGroup("");
      break;
    case "cabinClass":
      setCabinClass("");
      break;
    case "seatSelection":
      setSeatSelection("");
      break;
    case "addons":
      setAddons("");
      break;
    case "brandedFares":
      setBrandedFares("");
      break;
    case "fareFlexibility":
      setFareFlexibility("");
      break;
    case "bookingWindow":
      setBookingWindow("");
      break;
    case "travelSeason":
      setTravelSeason("");
      break;
    case "bookingTime":
      setBookingTime("");
      break;
    case "dayWeek":
      setDayWeek("");
      break;
    case "specialEvents":
      setSpecialEvents("");
      break;
    case "surgeThreshold":
      setSurgeThreshold("");
      break;
    case "responseStrategy":
      setResponseStrategy("");
      break;
    case "surgeMultiplier":
      setSurgeMultiplier("");
      break;
    case "monitoringFrequency":
      setMonitoringFrequency("");
      break;
    case "fromDate":
      setFromDate(null);
      break;
    case "toDate":
      setToDate(null);
      break;
    case "ruleName":
      setRuleName("");
      break;
    case "ruleDescription":
      setRuleDescription("");
      break;
    case "bookingValueThreshold":
      setBookingValueThreshold("");
      break;
    case "baseAmount":
      setBaseAmount("");
      break;
  }
};

return (
    <>
      <Box className="superAdminPage">
            <Box component="form">
                <Box className="feeModalForm">
                <Typography variant="h5" gutterBottom>Basic Information</Typography>
                <Box className="feeInputFieldWrap">
                    <div className="form-control inputFieldWrap">
                    <label>Rule Name</label>
                    <input type="text" className="inputField" value={ruleName} onChange={(e) => setRuleName(e.target.value)} />
                    {ruleName && (
                        <IconButton
                        size="small"
                        onClick={(e) => handleClear(e, "ruleName")}
                        className="clearFields clearInputs"
                        >
                        <ClearIcon fontSize="small" />
                        <Typography variant="caption" sx={{ ml: 0.5 }}>
                        Clear
                        </Typography>
                        </IconButton>
                    )}
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Rule Priority</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={rulePriority}
                        onChange={handleRulePriorityChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Rule Priority</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="High Priority">High Priority</MenuItem>
                        <MenuItem value="Medium Priority">Medium Priority</MenuItem>
                        <MenuItem value="Low Priority">Low Priority</MenuItem>
                        </Select>
                        {rulePriority && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "rulePriority")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <label>Effective Date</label>
                    <div onClick={() => setFromOpen(true)} style={{ position: "relative" }}>
                        <DatePicker
                            open={fromOpen}
                            onOpen={() => setFromOpen(true)}
                            onClose={() => setFromOpen(false)}
                            value={fromDate}
                            onChange={(newValue) => setFromDate(newValue)}
                            slotProps={{ textField: { fullWidth: true } }}
                            className='datePickerWrap superdropdown'
                        />
                        {fromDate && (
                            <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "fromDate")}
                            className="clearFields"
                            >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                            </IconButton>
                        )}
                        </div>
                    </LocalizationProvider>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <label>Expiry Date <small>(Optional)</small></label>
                        <div onClick={() => setToOpen(true)} style={{ position: "relative" }}>
                            <DatePicker
                                open={toOpen}
                                // onOpen={() => setToOpen(true)}
                                onClose={() => setToOpen(false)}
                                value={toDate}
                                onChange={handleDateChange}
                                slotProps={{ textField: { fullWidth: true } }}
                                className='datePickerWrap superdropdown'
                            />
                            {toDate && (
                                <IconButton
                                size="small"
                                onClick={(e) => handleClear(e, "toDate")}
                                className="clearFields"
                                >
                                <ClearIcon fontSize="small" />
                                <Typography variant="caption" sx={{ ml: 0.5 }}>
                                Clear
                                </Typography>
                                </IconButton>
                            )}
                        </div>
                    </LocalizationProvider>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Rule Description <small>(Optional)</small></label>
                    <input type="text" className="inputField" value={ruleDescription} onChange={(e) => setRuleDescription(e.target.value)} />
                    {ruleDescription && (
                        <IconButton
                        size="small"
                        onClick={(e) => handleClear(e, "ruleDescription")}
                        className="clearFields clearInputs"
                        >
                        <ClearIcon fontSize="small" />
                        <Typography variant="caption" sx={{ ml: 0.5 }}>
                        Clear
                        </Typography>
                        </IconButton>
                    )}
                    </div>
                </Box>
                </Box>
                <Box className="feeModalForm">
                <Typography variant="h5" gutterBottom>Pricing Configuration</Typography>
                <Box className="feeInputFieldWrap priceTabWrap">
                    <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 2 }}>
                        <Tab icon={<PersonIcon />} label="Per Passenger" iconPosition="start" />
                        <Tab icon={<AirplaneTicketIcon />} label="Per Ticket" iconPosition="start" />
                        <Tab icon={<EventNoteIcon />} label="Per Booking" iconPosition="start" />
                    </Tabs>
                    
                            {/* --- PER PASSENGER --- */}
                            {tab === 0 && (
                            <Box className="tab-fieldsWrap">
                                <div className="form-control inputFieldWrap">
                                    <label>Passenger Type</label>
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={passengerType}
                                        onChange={handlePassengerTypeChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Passenger Type</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="All Passengers">All Passengers</MenuItem>
                                        <MenuItem value="Adult (12+ years)">Adult (12+ years)</MenuItem>
                                        <MenuItem value="Child (2-11 years)">Child (2-11 years)</MenuItem>
                                        <MenuItem value="Infant (0-2 years)">Infant (0-2 years)</MenuItem>
                                        </Select>
                                        {passengerType && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "passengerType")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="form-control inputFieldWrap">
                                    <label>Age-based Pricing</label>
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={agebasedPricing}
                                        onChange={handleAgebasedPricingChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Age-based Pricing</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="Same fee for all ages">Same fee for all ages</MenuItem>
                                        <MenuItem value="Reduced fee for children/infants">Reduced fee for children/infants</MenuItem>
                                        <MenuItem value="Exempt infants from fee">Exempt infants from fee</MenuItem>
                                        </Select>
                                        {agebasedPricing && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "agebasedPricing")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                                <Typography className='tab-Msg'>
                                <b>Per Passenger:</b> Fee applies to each individual passenger. For a
                                family of 4, the fee is charged 4 times.
                                </Typography>
                            </Box>
                            )}
                    
                            {/* --- PER TICKET --- */}
                            {tab === 1 && (
                            <Box className="tab-fieldsWrap">
                                <div className="form-control inputFieldWrap">
                                    <label>Ticket Segments</label>
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={ticketSegments}
                                        onChange={handleTicketSegmentsChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Ticket Segments</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="All Segments">All Segments</MenuItem>
                                        <MenuItem value="Outbound Only">Outbound Only</MenuItem>
                                        <MenuItem value="Return Only">Return Only</MenuItem>
                                        <MenuItem value="First Segment Only">First Segment Only</MenuItem>
                                        </Select>
                                        {ticketSegments && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "ticketSegments")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="form-control inputFieldWrap">
                                    <label>Multi-segment Pricing</label>
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={multisegmentPricing}
                                        onChange={handleMultisegmentPricingChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Multi-segment Pricing</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="Fee per each segment">Fee per each segment</MenuItem>
                                        <MenuItem value="Capped at 2 segments">Capped at 2 segments</MenuItem>
                                        <MenuItem value="Progressive discount">Progressive discount</MenuItem>
                                        </Select>
                                        {multisegmentPricing && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "multisegmentPricing")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                                <Typography className='tab-Msg'>
                                <b>Per Ticket:</b> Fee applies to each flight segment/ticket. For a
                                round-trip, the fee may be charged twice (outbound + return).
                                </Typography>
                            </Box>
                            )}
                    
                            {/* --- PER BOOKING --- */}
                            {tab === 2 && (
                            <Box className="tab-fieldsWrap">
                                <div className="form-control inputFieldWrap">
                                    <label>Booking Value Threshold ($)</label>
                                    <input type="text" className="inputField" value={bookingValueThreshold} onChange={(e) => setBookingValueThreshold(e.target.value)} />
                                    {bookingValueThreshold && (
                                        <IconButton
                                        size="small"
                                        onClick={(e) => handleClear(e, "bookingValueThreshold")}
                                        className="clearFields clearInputs"
                                        >
                                        <ClearIcon fontSize="small" />
                                        <Typography variant="caption" sx={{ ml: 0.5 }}>
                                        Clear
                                        </Typography>
                                        </IconButton>
                                    )}
                                </div>
                                <div className="form-control inputFieldWrap">
                                    <label>Group Booking Rules</label> 
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={groupBookingRules}
                                        onChange={handleGroupBookingRulesChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Group Booking Rules</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="Single fee per booking">Single fee per booking</MenuItem>
                                        <MenuItem value="Capped at group size">Capped at group size</MenuItem>
                                        <MenuItem value="Bulk discount for 10+ passengers">Bulk discount for 10+ passengers</MenuItem>
                                        </Select>
                                        {groupBookingRules && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "groupBookingRules")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                                <Typography className='tab-Msg'>
                                <b>Per Booking:</b> Fee applies once per entire booking transaction,
                                regardless of number of passengers or tickets.
                                </Typography>
                            </Box>
                            )}
                                <div className="form-control inputFieldWrap">
                                    <label>Fee Type</label>
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={feeType}
                                        onChange={handleFeeTypeChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Fee Type</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="Fixed Amount">Fixed Amount</MenuItem>
                                        <MenuItem value="Percentage of Ticket">Percentage of Ticket</MenuItem>
                                        <MenuItem value="Tiered Pricing">Tiered Pricing</MenuItem>
                                        <MenuItem value="Dynamic Pricing">Dynamic Pricing</MenuItem>
                                        </Select>
                                        {feeType && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "feeType")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="form-control inputFieldWrap">
                                    <label>Base Amount ($)</label>
                                    <input type="text" className="inputField" value={baseAmount} onChange={(e) => setBaseAmount(e.target.value)} />
                                    {baseAmount && (
                                        <IconButton
                                        size="small"
                                        onClick={(e) => handleClear(e, "baseAmount")}
                                        className="clearFields clearInputs"
                                        >
                                        <ClearIcon fontSize="small" />
                                        <Typography variant="caption" sx={{ ml: 0.5 }}>
                                        Clear
                                        </Typography>
                                        </IconButton>
                                    )}
                                </div>
                                <div className="form-control inputFieldWrap">
                                    <label>Currency</label>
                                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                                        <Select
                                        className="commondropdown superdropdown"
                                        id="supplier-select"
                                        value={currency}
                                        onChange={handleCurrencyChange}
                                        displayEmpty
                                        renderValue={(selected) => {
                                            if (!selected) {
                                            return <span style={{ color: "#888" }}>Select Currency</span>;
                                            }
                                            return selected;
                                        }}
                                        >
                                        <MenuItem value="USD - US Dollar">USD - US Dollar</MenuItem>
                                        <MenuItem value="EUR - Euro">EUR - Euro</MenuItem>
                                        <MenuItem value="INR - Indian Rupee">INR - Indian Rupee</MenuItem>
                                        <MenuItem value="GBP - British Pound">GBP - British Pound</MenuItem>
                                        </Select>
                                        {currency && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleClear(e, "currency")}
                                            className="clearFields"
                                        >
                                            <ClearIcon fontSize="small" />
                                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                                            Clear
                                            </Typography>
                                        </IconButton>
                                        )}
                                    </FormControl>
                                </div>
                </Box>
                </Box>
                <Box className="feeModalForm">
                <Typography variant="h5" gutterBottom>Smart Targeting</Typography>
                <Box className="feeInputFieldWrap">
                    <div className="form-control inputFieldWrap">
                    <label>Origin Country/Region</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={originCountry}
                        onChange={handleOriginCountryChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Origin Country/Region</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="India">India</MenuItem>
                        <MenuItem value="United States">United States</MenuItem>
                        <MenuItem value="European Union">European Union</MenuItem>
                        <MenuItem value="Asia Pacific">Asia Pacific</MenuItem>
                        </Select>
                        {originCountry && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "originCountry")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Destination Country/Region</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={destinationCountry}
                        onChange={handleDestinationCountryChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Destination Country/Region</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="India">India</MenuItem>
                        <MenuItem value="United States">United States</MenuItem>
                        <MenuItem value="European Union">European Union</MenuItem>
                        <MenuItem value="Asia Pacific">Asia Pacific</MenuItem>
                        </Select>
                        {destinationCountry && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "destinationCountry")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Journey Type</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={journeyType}
                        onChange={handleJourneyTypeChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Journey Type</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Round Trip">Round Trip</MenuItem>
                        <MenuItem value="One Way">One Way</MenuItem>
                        <MenuItem value="Multi-City">Multi-City</MenuItem>
                        </Select>
                        {journeyType && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "journeyType")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Route Demand</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={routeDemand}
                        onChange={handleRouteDemandChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Route Demand</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="High Demand Routes">High Demand Routes</MenuItem>
                        <MenuItem value="Medium Demand Routes">Medium Demand Routes</MenuItem>
                        <MenuItem value="Low Demand Routes">Low Demand Routes</MenuItem>
                        </Select>
                        {routeDemand && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "routeDemand")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Flight Distance</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={flightDistance}
                        onChange={handleFlightDistanceChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Flight Distance</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Domestic ( 1000km)">Domestic ( 1000km)</MenuItem>
                        <MenuItem value="Regional (1000-3000km)">Regional (1000-3000km)</MenuItem>
                        <MenuItem value="International ( 3000km)">International ( 3000km)</MenuItem>
                        </Select>
                        {flightDistance && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "flightDistance")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Customer Type</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={customerType}
                        onChange={handleCustomerTypeChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Customer Type</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Business Travelers">Business Travelers</MenuItem>
                        <MenuItem value="Leisure Travelers">Leisure Travelers</MenuItem>
                        <MenuItem value="Corporate Accounts">Corporate Accounts</MenuItem>
                        <MenuItem value="Group Bookings">Group Bookings</MenuItem>
                        </Select>
                        {customerType && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "customerType")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Loyalty Tier</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={loyaltyTier}
                        onChange={handleLoyaltyTierChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Loyalty Tier</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Platinum Members">Platinum Members</MenuItem>
                        <MenuItem value="Gold Members">Gold Members</MenuItem>
                        <MenuItem value="Silver Members">Silver Members</MenuItem>
                        <MenuItem value="New Customers">New Customers</MenuItem>
                        </Select>
                        {loyaltyTier && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "loyaltyTier")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Booking Frequency</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={bookingFrequency}
                        onChange={handleBookingFrequencyChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Booking Frequency</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Frequent (10+ trips/year)">Frequent (10+ trips/year)</MenuItem>
                        <MenuItem value="Regular (3-10 trips/year)">Regular (3-10 trips/year)</MenuItem>
                        <MenuItem value="Occasional (1-2 trips/year)">Occasional (1-2 trips/year)</MenuItem>
                        <MenuItem value="First-time Bookers">First-time Bookers</MenuItem>
                        </Select>
                        {bookingFrequency && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "bookingFrequency")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Age Group</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={ageGroup}
                        onChange={handleAgeGroupChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Age Group</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Youth (18-25)">Youth (18-25)</MenuItem>
                        <MenuItem value="Adult (26-54)">Adult (26-54)</MenuItem>
                        <MenuItem value="Senior (55+)">Senior (55+)</MenuItem>
                        </Select>
                        {ageGroup && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "ageGroup")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Cabin Class</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={cabinClass}
                        onChange={handleCabinClassChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Cabin Class</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Economy">Economy</MenuItem>
                        <MenuItem value="Premium Economy">Premium Economy</MenuItem>
                        <MenuItem value="Business">Business</MenuItem>
                        <MenuItem value="First Class">First Class</MenuItem>
                        </Select>
                        {cabinClass && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "cabinClass")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Seat Selection</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={seatSelection}
                        onChange={handleSeatSelectionChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Seat Selection</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Preferred Seats">Preferred Seats</MenuItem>
                        <MenuItem value="Extra Legroom">Extra Legroom</MenuItem>
                        <MenuItem value="Window Seats">Window Seats</MenuItem>
                        <MenuItem value="Aisle Seats">Aisle Seats</MenuItem>
                        </Select>
                        {seatSelection && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "seatSelection")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Add-ons</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={addons}
                        onChange={handleAddonsChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Add-ons</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Meals Included">Meals Included</MenuItem>
                        <MenuItem value="Extra Baggage">Extra Baggage</MenuItem>
                        <MenuItem value="Travel Insurance">Travel Insurance</MenuItem>
                        <MenuItem value="All Add-ons">All Add-ons</MenuItem>
                        </Select>
                        {addons && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "addons")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Branded Fares</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={brandedFares}
                        onChange={handleBrandedFaresChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Branded Fares</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Basic Economy">Basic Economy</MenuItem>
                        <MenuItem value="Main Cabin">Main Cabin</MenuItem>
                        <MenuItem value="Comfort">Comfort</MenuItem>
                        <MenuItem value="Premium Select">Premium Select</MenuItem>
                        <MenuItem value="Business Select">Business Select</MenuItem>
                        <MenuItem value="First Class Suite">First Class Suite</MenuItem>
                        </Select>
                        {brandedFares && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "brandedFares")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Fare Flexibility</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={fareFlexibility}
                        onChange={handleFareFlexibilityChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Fare Flexibility</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Restricted (No changes)">Restricted (No changes)</MenuItem>
                        <MenuItem value="Standard (Change fee)">Standard (Change fee)</MenuItem>
                        <MenuItem value="Flexible (Free changes)">Flexible (Free changes)</MenuItem>
                        <MenuItem value="Fully Refundable">Fully Refundable</MenuItem>
                        </Select>
                        {fareFlexibility && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "fareFlexibility")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                </Box>
                <FormGroup>
                    <FormControlLabel required control={<Checkbox />} label="Enable airline-specific branded fare targeting" />
                </FormGroup>
                </Box>
                <Box className="feeModalForm">
                <Typography variant="h5" gutterBottom>Advanced Conditions</Typography>
                <Box className="feeInputFieldWrap">
                    <div className="form-control inputFieldWrap">
                    <label>Booking Window</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={bookingWindow}
                        onChange={handleBookingWindowChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Booking Window</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="60+ days advance">60+ days advance</MenuItem>
                        <MenuItem value="30-60 days advance">30-60 days advance</MenuItem>
                        <MenuItem value="7-30 days advance">7-30 days advance</MenuItem>
                        <MenuItem value="Last minute (0-7 days)">Last minute (0-7 days)</MenuItem>
                        </Select>
                        {bookingWindow && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "bookingWindow")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Travel Season</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={travelSeason}
                        onChange={handleTravelSeasonChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Travel Season</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Peak Season">Peak Season</MenuItem>
                        <MenuItem value="Shoulder Season">Shoulder Season</MenuItem>
                        <MenuItem value="Off Season">Off Season</MenuItem>
                        <MenuItem value="Holiday Periods">Holiday Periods</MenuItem>
                        </Select>
                        {travelSeason && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "travelSeason")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Booking Time of Day</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={bookingTime}
                        onChange={handleBookingTimeChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Booking Time</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Morning (6 AM - 12 PM)">Morning (6 AM - 12 PM)</MenuItem>
                        <MenuItem value="Afternoon (12 PM - 6 PM)">Afternoon (12 PM - 6 PM)</MenuItem>
                        <MenuItem value="Evening (6 PM - 11 PM)">Evening (6 PM - 11 PM)</MenuItem>
                        <MenuItem value="Night (11 PM - 6 AM)">Night (11 PM - 6 AM)</MenuItem>
                        </Select>
                        {bookingTime && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "bookingTime")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Day of Week</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={dayWeek}
                        onChange={handleDayWeekChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Day of Week</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Weekdays">Weekdays</MenuItem>
                        <MenuItem value="Weekends">Weekends</MenuItem>
                        <MenuItem value="Monday">Monday</MenuItem>
                        <MenuItem value="Friday">Friday</MenuItem>
                        </Select>
                        {dayWeek && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "dayWeek")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Special Events</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={specialEvents}
                        onChange={handleSpecialEventsChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Special Events</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Festival Periods">Festival Periods</MenuItem>
                        <MenuItem value="Business Conferences">Business Conferences</MenuItem>
                        <MenuItem value="Sports Events">Sports Events</MenuItem>
                        <MenuItem value="Emergency Situations">Emergency Situations</MenuItem>
                        </Select>
                        {specialEvents && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "specialEvents")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                </Box>
                <Box className="checkBoxGroup">
                <FormGroup>
                    <FormControlLabel required control={<Checkbox />} label="Enable airline-specific branded fare targeting" />
                </FormGroup>
                <FormGroup>
                    <FormControlLabel required control={<Checkbox />} label="Enable airline-specific branded fare targeting" />
                </FormGroup>
                </Box>
                <Box className="feeInputFieldWrap">
                <div className="form-control inputFieldWrap">
                    <label>Surge Threshold</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={surgeThreshold}
                        onChange={handleSurgeThresholdChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Surge Threshold</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="When 80%+ seats booked">When 80%+ seats booked</MenuItem>
                        <MenuItem value="When 70%+ seats booked">When 70%+ seats booked</MenuItem>
                        <MenuItem value="When 90%+ seats booked">When 90%+ seats booked</MenuItem>
                        <MenuItem value="Custom threshold">Custom threshold</MenuItem>
                        </Select>
                        {surgeThreshold && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "surgeThreshold")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Response Strategy</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={responseStrategy}
                        onChange={handleResponseStrategyChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Response Strategy</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Match competitor fees">Match competitor fees</MenuItem>
                        <MenuItem value="Undercut by $5-10">Undercut by $5-10</MenuItem>
                        <MenuItem value="Maintain premium (+$10-20)">Maintain premium (+$10-20)</MenuItem>
                        <MenuItem value="Alert only (no auto-adjust)">Alert only (no auto-adjust)</MenuItem>
                        </Select>
                        {responseStrategy && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "responseStrategy")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Surge Multiplier</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={surgeMultiplier}
                        onChange={handleSurgeMultiplierChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Surge Multiplier</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="1.5x (50% increase)">1.5x (50% increase)</MenuItem>
                        <MenuItem value="2x (100% increase)">2x (100% increase)</MenuItem>
                        <MenuItem value="2.5x (150% increase)">2.5x (150% increase)</MenuItem>
                        <MenuItem value="3x (200% increase)">3x (200% increase)</MenuItem>
                        </Select>
                        {surgeMultiplier && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "surgeMultiplier")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                    <div className="form-control inputFieldWrap">
                    <label>Monitoring Frequency</label>
                    <FormControl sx={{ minWidth: 265 }} className="commondropdownWrap">
                        <Select
                        className="commondropdown superdropdown"
                        id="supplier-select"
                        value={monitoringFrequency}
                        onChange={handleMonitoringFrequencyChange}
                        displayEmpty
                        renderValue={(selected) => {
                            if (!selected) {
                            return <span style={{ color: "#888" }}>Select Monitoring Frequency</span>;
                            }
                            return selected;
                        }}
                        >
                        <MenuItem value="Real-time">Real-time</MenuItem>
                        <MenuItem value="Every hour">Every hour</MenuItem>
                        <MenuItem value="Daily">Daily</MenuItem>
                        <MenuItem value="Weekly">Weekly</MenuItem>
                        </Select>
                        {monitoringFrequency && (
                        <IconButton
                            size="small"
                            onClick={(e) => handleClear(e, "monitoringFrequency")}
                            className="clearFields"
                        >
                            <ClearIcon fontSize="small" />
                            <Typography variant="caption" sx={{ ml: 0.5 }}>
                            Clear
                            </Typography>
                        </IconButton>
                        )}
                    </FormControl>
                    </div>
                </Box>
                </Box>
            </Box>
            <Box display="flex" justifyContent="flex-end">
                <Button variant="contained" className='superBtn'>Save</Button>
            </Box>
      </Box>
    </>
  )
}

export default SuperAdmin
